export default {
  chart_assets: 'Assets',
  lbl_select_files: 'Select File(s)',
  lbl_user_info: 'Personal user\u{27}s info',
  lbl_email: 'Email',
  lbl_pwd: 'Password',
  lbl_contact_us: 'Contact us',
  lbl_new_pwd: 'New password',
  lbl_pwd_confirm: 'Confirm password',
  lbl_confirm: 'Confirm',
  lbl_asset: 'Asset',
  lbl_choose_asset: 'Asset',
  lbl_amount: 'Amount',
  lbl_give: 'You send',
  lbl_get: 'You get',
  lbl_balance: 'Balance',
  lbl_request_new_email: 'Request new email',
  lbl_almost_done: 'Almost done',
  lbl_settings: 'Settings',
  lbl_verification: 'Verification',
  lbl_acc_verification: 'Account verification',
  lbl_help: 'Help',
  lbl_signout: 'Sign Out',
  lbl_signin: 'Sign In',
  lbl_signup: 'Sign Up',
  lbl_logout: 'Log out',
  lbl_zeros: 'Hide zero balances',
  lbl_my_account: 'My account',
  lbl_start_date: 'Start date',
  lbl_end_date: 'End date',
  lbl_account: 'Account',
  lbl_account_info: 'Account info',
  lbl_account_type: 'Account type',
  lbl_taurus_id: 'UPLATA card',
  lbl_uplata_insha_name: 'Visa Insha',
  lbl_uplata_insha: 'Visa Insha cards',
  lbl_no_uplata_insha: 'Visa Insha cards are absent',
  lbl_no_xpay: 'Cards are absent',
  lbl_xpay: 'Payment cards',
  lbl_add_xpay: 'Enter a number of payment card to add',
  lbl_invalid_uplata_len: '16-th digit number',
  lbl_add_uplata_insha: 'Enter a number of Visa Insha card to add',
  lbl_taid: 'UPLATA cards',
  lbl_no_taid: 'UPLATA cards are absent',
  lbl_invalid_taid_len: 'enter 7-th digit number',
  lbl_add_taurus: 'Enter a number of UPLATA card to add',
  lbl_auto_withdraw: 'autowithdraw',
  lbl_delete_confirm_title: 'Confirm deletion',
  lbl_delete: 'Delete',
  lbl_card_add: 'Add card',
  lbl_no_card: 'No cards selected',
  lbl_card_delete: 'delete card',
  lbl_id_delete_confirm: 'Are you sure to delete card %{id} ?',
  lbl_id_add_confirm: 'Are you sure to add card %{id} ?',
  lbl_autowithdraw_confirm: 'Are you sure to change autowithdraw parameters?',
  lbl_number_is_exists: 'Number already exists in the list',
  lbl_verified: 'Verified user',
  lbl_got_it: 'Got it',
  lbl_unverified: 'Unverified user',
  lbl_my_wallet: 'Wallet',
  lbl_transactions: 'Transactions',
  lbl_dashboard: 'Dashboard',
  lbl_deposit: 'Deposit',
  lbl_deposit_white: 'To whitelisted wallet',
  lbl_refund: 'Refund',
  lbl_reason: 'Reason',
  lbl_aml_title: 'The transaction requires attention',
  lbl_aml_title_large: 'The transaction requires attention. Elevated risk indicators were detected, or a processing error occurred. Check the details below and make a decision.',
  lbl_check_again: 'Check again',
  lbl_withdraw: 'Withdraw',
  lbl_refill: 'Top up',
  lbl_withdrawal_req: 'Withdrawal requests',
  lbl_refund_history: 'Refund history',
  lbl_send: 'Send',
  lbl_send_immediatly: 'Send immediately',
  lbl_send_mass: 'Mass transfer',
  lbl_cashbox: 'Cashbox requests',
  lbl_tokens: 'Tokenization',
  lbl_trade: 'Trade',
  lbl_create_wallet: 'Create wallet',
  lbl_create_token: 'Create token',
  lbl_create_sale: 'Create project',
  lbl_creation_sale: 'Creation fund',
  lbl_explore_tokens: 'Explore tokens',
  lbl_explore_sales: 'Explore project',
  lbl_my_funds: 'My project',
  lbl_history: 'Transaction history',
  lbl_history_w: 'Withdrawal history',
  lbl_history_e: 'Issuance history',
  lbl_partner_cabinet: 'Partner Cabinet',
  lbl_business_directory: 'Business directory',
  lbl_cancel: 'Cancel',
  lbl_sub_transfer: 'Transfer',
  lbl_export: 'Export',
  lbl_wallet: 'Wallet',
  lbl_wallet_onetime: 'Onetime wallet',
  lbl_fees_label: 'Fees',
  lbl_something_wrong: 'something went wrong, pleasy try again later',
  lbl_date: 'Date',
  lbl_time_to_tx: 'Time to send the transaction',
  lbl_cancel_refund: 'Cancel refund',
  lbl_time_to_refund: 'You can cancel the return until the timer runs out',
  lbl_time_optional: 'Time',

  lbl_id: 'ID',
  lbl_temporary_wallet: 'Temporary wallet',
  lbl_refund_address: 'Refund address',
  lbl_sum_refund: 'Refund amount',
  lbl_refund_balance: 'Balance',
  lbl_refund_asset: 'Asset',
  lbl_refund_date: 'Creation date',
  lbl_refund_hash: 'Hash',
  lbl_refund_status: 'Status',
  lbl_refund_number: 'Order number',
  lbl_refund_canceled: 'Failure',
  lbl_refund_success: 'Success',
  lbl_refund_pending: 'Pending',
  lbl_refund_amount: 'Refund amount',
  lbl_address: 'Address',
  lbl_address_refund: 'Refund Address',
  lbl_commision: 'Commission',

  lbl_to_app: 'To app', // back to app
  lbl_hash: 'Hash',
  lbl_order_id: 'Order number',
  lbl_order_uid: 'Order ID',
  lbl_internal_hash: 'Internal hash',
  lbl_order_amount: 'Order amount',
  lbl_order_network: 'Order network',
  lbl_tx_type: 'Transaction type',
  lbl_status: 'Status',
  lbl_my: 'Available requests',
  lbl_main_user_id: 'Main user id',
  lbl_current_lvl: 'Сurrent required level to approve',
  lbl_total_levels: 'Total levels to approve',
  lbl_pending: 'Pending',
  lbl_confirmed: 'Approved',
  lbl_approvers: 'Approvers',
  lbl_signatures: 'Signatures',
  lbl_level_1: 'Operational',
  lbl_level_2: 'Controller',
  lbl_level_3: 'Head of direction',
  lbl_level_4: 'Director',
  lbl_canceled: 'Rejected',
  lbl_check_sign: 'Pending approval',
  lbl_check_sign_again: 'Check again',
  lbl_counterparty: 'Counterparty',
  lbl_sender: 'Sender',
  lbl_receiver: 'Receiver',
  lbl_fixed_fee: 'Fixed fee',
  lbl_percent_fee: 'Percent fee',
  lbl_total_fee: 'Total fee',
  lbl_exchange: 'Exchange',
  lbl_exchange_asset: 'Currency',
  lbl_limit_s: 'Amount below the minimum deposit limit',
  lbl_limit_title: 'Deposit Limit',
  lbl_exchange_buy: 'Buy',
  lbl_exchange_sell: 'Sell',
  lbl_add_note: 'Add a note',
  lbl_description: 'Description',
  lbl_client: 'Client',
  lbl_direction_group: 'Direction group',
  lbl_client_group: 'Client group',
  lbl_fund_name: 'Fund name',
  lbl_sale_name: 'Fund name',
  lbl_base_asset: 'Base asset',
  lbl_default_quote_asset: 'Quote asset',
  lbl_fee_paid: 'Fee paid',
  lbl_price: 'Price',
  lbl_transfer_fee: 'Transfer fee',
  lbl_destination_asset: 'Destination asset',
  lbl_destination_amount: 'Destination amount',
  lbl_source_amount: 'Source amount',
  lbl_ok: 'OK',
  lbl_from: 'From',
  lbl_tfa_code: '2FA code',
  lbl_add: 'Add',
  lbl_add_more: 'Add more',
  lbl_added_video: 'Added video:',
  lbl_submit: 'Submit',
  lbl_secret: 'Secret',
  lbl_recovery_seed: 'Recovery seed',
  lbl_exchange_rates: 'Exchange rates in relation to %{asset}',
  lbl_transaction_details: 'Transaction details',
  lbl_view_more: 'View more',
  lbl_all_history: 'History',
  lbl_all: 'All',
  lbl_mine: 'My',
  lbl_close: 'Cancel',
  lbl_enroll: 'Enroll',
  lbl_put_aside: 'Put aside',
  lbl_check_crystal: 'Check manually in Crystal',
  lbl_credit_dirty: 'To graylisted wallet',
  lbl_user_id: 'User id',
  lbl_recipient_email_or_account: 'Recipient email or account ID',
  lbl_recipient_email: 'Recipient email',
  lbl_recipient: 'Recipient',
  lbl_recipient_account_id: 'Recipient account ID',
  lbl_recipient_balance_id: 'Recipient balance ID',
  lbl_recipient__email: 'Recipient email',
  lbl_requestor: 'Requestor',
  lbl_requestor_account_id: 'Requestor account ID',
  lbl_requestor_id_or_email: 'Requestor ID or email',
  lbl_source_fees: 'Source fees',
  lbl_fixed_percent: '(Fixed/percent)',
  lbl_destination_fees: 'Destination fees',
  lbl_recipient_fixed_fee: 'Recipient fixed fee',
  lbl_recipient_percent_fee: 'Recipient percent fee',
  lbl_sender_balance_id: 'Recipient balance ID',
  lbl_sender_fixed_fee: 'Recipient fixed fee',
  lbl_sender_percent_fee: 'Recipient percent fee',
  lbl_fixed: 'Fixed',
  lbl_percent: 'Percent',
  lbl_subject: 'Subject',
  lbl_token_code: 'Token code',
  lbl_token_name: 'Token name',
  lbl_token_icon: 'Upload icon',
  lbl_token_terms: 'Upload terms',
  lbl_token_preissued_asset_signer: 'Preissued asset signer',
  lbl_token_max_issuance_amount: 'Max issuance amount',
  lbl_token_policies: 'Policies',
  lbl_token_initial_preissued_amount: 'Initial preissued amount',
  lbl_is_transferable: 'Create transferable asset',
  lbl_is_additional_issuance_allowed: 'Is additional issuance allowed',
  lbl_is_tradable: 'Is tradable',
  lbl_fees: 'Fee',
  lbl_sender_fees: 'Sender fees',
  lbl_giftmall: 'Market',
  lbl_recipient_fees: 'Recipient fees',
  lbl_go_back: 'Go back',
  lbl_delete_notif: 'Delete this notification',
  lbl_go_back_2: 'Go back',
  lbl_make_recovery: 'Recover',
  lbl_validate_seed: 'Enter your seed phrase',
  lbl_seed: 'Seed phrase',
  lbl_first_name: 'First name',
  lbl_last_name: 'Last name',
  lbl_line_1: 'Line 1',
  lbl_line_2: 'Line 2',
  lbl_city: 'City',
  lbl_country: 'Country',
  lbl_state: 'State',
  lbl_postal_code: 'Postal code',
  lbl_kyc: 'User detailed info',
  lbl_kyc_photo: 'Photo',
  lbl_kyc_selfie: 'Selfie with verification code',
  lbl_kyc_id: 'ID document',
  lbl_kyc_proof: 'Proof of address',
  lbl_done: 'Done',
  lbl_date_of_birth: 'Date of birth',
  lbl_id_document_exp_date: 'ID document expiration date',
  lbl_code: 'Code',
  lbl_document_type: 'Document type',
  lbl_owner: 'Owner',
  lbl_avalilable_for_iss: 'Available',
  lbl_name: 'Name',
  lbl_signer: 'Signer',
  lbl_maximum: 'Maximum',
  lbl_issued: 'Issued',
  lbl_policy: 'Policy',
  lbl_policies: 'Policies',
  lbl_terms: 'Terms',
  lbl_token_details: 'Token details',
  lbl_add_to_balances: 'Add to my balances',
  lbl_balance_exists: 'Balance exists',
  lbl_view_history: 'View history',
  lbl_user: 'user',
  lbl_sub: 'Sub account',
  lbl_new: 'New',
  lbl_new_dir: 'New direction',
  lbl_new_client: 'New client',
  lbl_sub_edit: 'Edit',
  lbl_subs: 'Sub accounts',
  lbl_direction: 'Direction',
  lbl_no_wallets: 'No subaccounts for this currency',
  lbl_no_funds: 'Unallocated funds',
  lbl_aml_notify_inc: 'Incoming — AML notifications',
  lbl_aml_notify_out: 'Outgoing — AML notifications',
  lbl_aml_error_out: 'Outgoing — AML error notifications',
  lbl_aml_error_inc: 'Incoming — AML error notifications',
  lbl_lymit_notify: 'Limit notifications',
  lbl_inc_notify: 'Incoming notifications',
  lbl_out_notify: 'Outcoming notifications',
  lbl_group_name: 'Group by client',
  lbl_group_decs: 'Group by direction',
  lbl_add_group_decs: 'Additionally group by direction',
  lbl_add_group_client: 'Additionally group by client',
  lbl_group_add: 'all',
  lbl_userBlocked: 'User is blocked',
  lbl_requests: 'Requests',
  lbl_fee: 'Fees',
  lbl_request_state: 'Request state',
  lbl_token_creation: 'Token creation',
  lbl_sale_creation: 'Fund creation',
  lbl_manual_issuance: 'Manual issuance',
  lbl_token_creation_requests: 'Token creation requests',
  lbl_choose_image: 'Choose an image from your PC',
  lbl_chose_image_token: 'Drag and drop an image here<br> that will become the logo of your asset',
  lbl_chose_image_campaign: 'Drag and drop an image here<br> that will serve as a preview of your campaign',
  lbl_no_token_creation_requests: 'No token creation requests',
  lbl_no_token_creation_requests_desc: 'Here will be the list of your token creation requests',
  lbl_created_at: 'Created at',
  lbl_revoked: 'Revoked',
  lbl_updated_at: 'Updated at',
  lbl_update: 'Refresh',
  lbl_reference: 'Reference',
  lbl_view_sale: 'View the fund',
  lbl_create_issuance: 'Create issuance',
  lbl_sender_fee: 'Sender fee',
  lbl_recipient_fee: 'Recipient fee',
  lbl_fee_from_source: 'Sender paid fees',
  lbl_sender_fee_asset: 'Sender fee asset',
  lbl_recipient_fee_asset: 'Recipient fee asset',
  lbl_sort_by: 'Sort by',
  lbl_reject_message: 'Reject message',
  lbl_information: 'Information',
  lbl_not_available: 'One last moment',
  lbl_token_not_available_exp: 'Token creation is available only for corporate users, complete verification to become one.',
  lbl_token_not_available_yet: 'Please create token before creating fund',
  lbl_issuance_not_available_exp: 'Issuance creation is available only for corporate users, complete verification to become one.',
  lbl_issuance_not_available_yet: 'Please create token before creating issuance',
  lbl_preissuance_not_available_exp: 'Pre-issuance upload is available only for corporate users, complete verification to become one.',
  lbl_not_available_exp: '%{screen} is available only for verified users, complete verification to become one.',
  lbl_upload_preissuance: 'Upload pre-issuance',
  lbl_clear: 'Clear',
  lbl_upload: 'Upload',
  lbl_company: 'Company',
  lbl_headquarters: 'Headquarters',
  lbl_industry: 'Industry',
  lbl_founded: 'Founded',
  lbl_team_size: 'Team size',
  lbl_homepage: 'Homepage',
  lbl_edit_details: 'Edit Details',
  lbl_loading: 'Loading...',
  lbl_no_data: 'No data',
  lbl_your_wallet: 'Your wallet',
  lbl_wait_30: 'Please use the one-time wallet address below only until the counter runs out',
  lbl_timer_error: 'something went wrong, please reload the page',
  lbl_create_btn: 'New addition',
  lbl_to_upload: 'To upload:',
  lbl_street_name: 'Street name',
  lbl_upload_docs: 'Please, upload the following documents',
  lbl_upload_doc: 'Please, upload the following document',
  lbl_agree_submit: 'Agree & submit information',
  lbl_pay_all_fees: 'Pay fees',
  lbl_residence_country: 'Residence country',
  lbl_zip_code: 'Zip code',
  lbl_limits: 'Limits',
  lbl_note: 'Note',
  lbl_send_request: 'Send request',
  lbl_to: 'To',
  lbl_request_type: 'Request type',
  lbl_more: 'More',
  lbl_upload_documents: 'Upload documents',
  lbl_request_creation_date: 'Request creation date',
  lbl_requesting: 'Requesting',
  lbl_contracts: 'Contracts',
  lbl_market: 'Market',
  lbl_yes: 'Yes',
  lbl_no: 'No',
  lbl_documents: 'Documents',
  lbl_document: 'Document',
  lbl_submitted_by: 'Submitted by',
  lbl_type: 'Type',
  lbl_archive: 'Archive',
  lbl_reject: 'Reject',
  lbl_funds: 'Funds',
  lbl_projects: 'Projects',
  lbl_open: 'Open',
  lbl_reject_request: 'Reject request',
  lbl_reject_reason: 'Reject reason',
  lbl_contracts_not_available_exp: 'Contracts are available only for verified users, complete verification to become one.',
  lbl_see_details_in_contract: 'See details in contract.',
  lbl_invoice_number: 'Invoice number',
  lbl_investment_portfolio: 'Investment portfolio',
  lbl_portfolio_investments: 'Portfolio investments',
  lbl_investment: 'Investment',
  lbl_available: 'Available',
  lbl_locked: 'Locked',
  lbl_current_price: 'Current price',
  lbl_max_issuance: 'Max issuance',
  lbl_no_investment_tokens: 'No investment tokens in your portfolio',
  lbl_no_investment_tokens_desc: 'Here will be the list of your investment tokens',
  lbl_card_add_uplata: 'Enter Uplata TaID to add your card',
  lbl_confirm_send: 'Confirm',
  lbl_current_balance: 'Balance: %{amount} %{asset}',
  lbl_sub_current_balance: 'Sub wallet balance: %{amount} %{asset}',
  lbl_campaign_status: 'Campaign status',
  lbl_search_campaign: 'Search by project name...',
  lbl_search_btn: 'Search',
  lbl_history_btn: 'Delegation history',
  lbl_delegate_btn: 'Delegate',
  lbl_return_btn: 'Revoke',
  lbl_delegate_text: 'You have delegated your rights to',
  lbl_delegated_to_you: 'You have been delegated rights from %{user} your current level now is %{level} ends %{date}',
  lbl_status_open: 'active',
  lbl_status_canceled: 'canceled',
  lbl_status_closed: 'closed',
  lbl_enter_quantity: 'Enter quantity',
  lbl_back_to_sale: 'Back to campaign',
  lbl_dividends_pay: 'Payment of dividends',
  lbl_email_2: 'Email',
  lbl_tokens_assets: 'Total assets',
  lbl_accept: 'Accept',
  lbl_go_to_pay: 'Go to payout',
  lbl_go_to_section: 'Go to section ',
  lbl_pdf_5mb: 'Only PDF format, max 5 MD',
  lbl_publish_file: 'Publish',
  lbl_copy: 'Copy',
  lbl_month: 'month',
  lbl_months: 'months',
  lbl_months_2: 'months',
  lbl_back_to_settings: 'Back to settings',
  lbl_confirmation: 'Confirmation',
  lbl_choose_account_type: 'Choose account type',
  lbl_to_dashboard: 'To home page',
  lbl_notifications: 'Notifications',
  lbl_continue: 'Continue',
  lbl_lost_2fa: 'Lost 2FA',
  lbl_recover_2fa: 'Recover 2-Factor authentication',
  lbl_add_2fa: 'Add 2-Factor authentication'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/labels.js